// TODO: feature #3 — full historical view with filters (repo, service, source,
// time range) and search. The skeleton ships only a basic table.
import { Link, useSearchParams } from "react-router-dom";
import { useRuns } from "../../store/hooks.js";
import { StatusDot } from "../../components/StatusDot.js";
import { SummaryCell } from "../../components/SummaryCell.js";
import { Timestamp } from "../../components/Timestamp.js";
import { formatDurationMs } from "../../lib/time.js";
import { pageSearch, parsePageParam, splitPage } from "./page-param.js";

const PAGE_SIZE = 50;

export function RunList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parsePageParam(searchParams.get("page"), PAGE_SIZE);
  const setPage = (next: number) => setSearchParams((prev) => pageSearch(prev, next));
  const q = useRuns({ limit: PAGE_SIZE + 1, offset: page * PAGE_SIZE });

  const { rows, hasNext } = splitPage(q.data ?? [], PAGE_SIZE);
  const hasPrev = page > 0;

  return (
    <section className="panel">
      <div className="panel-header">All runs (basic)</div>
      {q.isError ? (
        <div style={{ padding: 16, color: "var(--err)" }}>
          Failed to load runs: {String((q.error as Error).message ?? q.error)}
        </div>
      ) : q.isLoading ? (
        <div style={{ padding: 16 }}>Loading…</div>
      ) : rows.length === 0 ? (
        <div style={{ padding: 16, color: "var(--muted)" }}>
          {page === 0 ? "No runs yet." : "No more runs."}
        </div>
      ) : (
        <table className="mobile-cards">
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th>Source</th>
              <th>Repo</th>
              <th>Host</th>
              <th>Started</th>
              <th>Duration</th>
              <th>Exit</th>
              <th>Summary</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.trace_id}>
                <td className="mc-status">
                  <StatusDot status={r.status} />
                </td>
                <td className="mc-title">
                  <Link to={`/runs/${r.trace_id}`}>{r.name}</Link>
                </td>
                <td data-label="Source">{r.source}</td>
                <td data-label="Repo">{r.repo ?? "—"}</td>
                <td data-label="Host">{r.host ?? "—"}</td>
                <td data-label="Started">
                  <Timestamp iso={r.started_at} />
                </td>
                <td data-label="Duration">{formatDurationMs(r.duration_ms)}</td>
                <td data-label="Exit">{r.exit_code ?? "—"}</td>
                <SummaryCell run={r} />
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div style={pager}>
        <button
          type="button"
          style={pageBtn}
          disabled={!hasPrev || q.isFetching}
          onClick={() => setPage(Math.max(0, page - 1))}
        >
          ← Prev
        </button>
        <span style={{ color: "var(--muted)", fontSize: 12 }}>
          Page {page + 1}
          {q.isFetching ? " · loading…" : ""}
        </span>
        <button
          type="button"
          style={pageBtn}
          disabled={!hasNext || q.isFetching}
          onClick={() => setPage(page + 1)}
        >
          Next →
        </button>
      </div>
    </section>
  );
}

const pager: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 12,
  padding: "12px 16px",
  borderTop: "1px solid var(--border)",
};

const pageBtn: React.CSSProperties = {
  background: "transparent",
  color: "var(--muted)",
  border: "1px solid var(--border)",
  borderRadius: 4,
  padding: "4px 12px",
  fontSize: 12,
  cursor: "pointer",
};
